import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import Link from 'next/link';
import { useQuery, useApolloClient } from '@apollo/react-hooks';
import _ from 'lodash';
import Router from 'next/router';
import Layout from '../../components/Layout';
import Container from '../../components/Container';

import ConsultantIcon from '../../assets/svg/microsaltsIcon01';
import ClinicaldietitianIcon from '../../assets/svg/microsaltsIcon02';
import DietitianIcon from '../../assets/svg/microsaltsIcon03';
import CookIcon from '../../assets/svg/microsaltsIcon04';
import Plus from '../../assets/svg/bluePlus';

import MicrosaltsBanner from '../../assets/images/microsalts_banner.png';
import DesktopMicrosaltsBanner from '../../assets/images/desktop_microsalts_banner.png';
import MenuDevelopmentBackground from '../../assets/images/menu-dev.png';
import DesktopMenuDevelopmentBackground from '../../assets/images/desktop_menu_dev.png';
import FooterBanner from '../../assets/images/microsalts_footer_banner.png';
import DesktopFooterBanner from '../../assets/images/desktop_microsalts_footer_banner.png';

import CookTeam01 from '../../assets/images/partner01.png';
import CookTeam02 from '../../assets/images/Hyatt-Logo.png';
import CookTeam03 from '../../assets/images/Le_Cordon_Blue.png';

import Sopoong from '../../assets/images/sopoong.png';
import Primer from '../../assets/images/primer.png';
import Sk from '../../assets/images/sk.png';
import Fact from '../../assets/images/fact.png';
import NPOIT from '../../assets/images/npoit.png';
import SeoulCenter from '../../assets/images/seoulcenter.png';
import SuwonWomen from '../../assets/images/suwon.png';
import LH from '../../assets/images/LH.png';
import KAIST from '../../assets/images/KAIST.png';
import NEPHROLOGY from '../../assets/images/Frame.png';
import KDB from '../../assets/images/KDB.png';
import AIA from '../../assets/images/AIA.png';
import SeoulHub from '../../assets/images/seoulhub.png';

import * as AuthQueries from '../auth/queries';
import * as DiagnosisReportQueries from '../diagnosisReport/queries';

const MicrosaltsIntroduction = () => {
  const client = useApolloClient();
  const {
    data: {
      auth: { isLoggedIn }
    }
  } = useQuery(AuthQueries.AUTH);
  const { data: allRecordResultData } = useQuery(DiagnosisReportQueries.ALL_RECORD_RESULT);
  const allRecordResult = _.get(allRecordResultData, 'allRecordResult');
  const allRecordResultExist = !_.isEmpty(allRecordResult)

  return (
    <Layout>
      <MicrosaltsIntroductionSection>
        <MicrosaltsIntroductionContainer>
          <Row>
            <Col span={0} md={0} />
            <Col span={24} md={24}>
              <div className="microsalts-introduction-div">
                <span>eats my pleasure</span>
                <h1>
                  누구나 <strong>즐겁게 </strong>
                  먹을 수 있다.
                </h1>
                <Underline />
                <Description>
                  맛있저염은 질병 또는 물리적인 이유로
                  <br />
                  식사를 하는데 어려움을 겪고 있는 분들에게
                  <br />
                  <strong>한 끼 식사의 즐거움</strong>을 되찾아 드립니다.
                </Description>
              </div>
            </Col>
            <Col span={0} md={0} />
          </Row>
        </MicrosaltsIntroductionContainer>
      </MicrosaltsIntroductionSection>

      <MicrosaltsHistorySection>
        <MicrosaltsHistoryContainer>
          <Row>
            <Col span={24} md={24}>
              <Title>맛있저염이 달려온 길</Title>
              <div className="history-list-div">
                <div className="history-div">
                  <div className="date">2016.11</div>
                  <div className="circle" />
                  <div className="list">
                    '맛있저염'설립
                    <br /> LH 토지주택공사 '소셜벤처 2기' 선정
                  </div>
                </div>
                <div className="history-div">
                  <div className="date">2017.03</div>
                  <div className="circle" />
                  <div className="list">
                    사회적기업진흥원
                    <br /> '사회적기업 육성사업 6기 선정'
                  </div>
                </div>
                <div className="history-div">
                  <div className="date">2017.04</div>
                  <div className="circle" />
                  <div className="list">서울시 먹거리 창업센터 입주기업</div>
                </div>
                <div className="history-div">
                  <div className="date">2017.09</div>
                  <div className="circle" />
                  <div className="list">
                    IT비영리 재단 DS I D-lab 2기 선정
                    <br />
                    농업실용화재단보육업체 선정
                  </div>
                </div>
                <div className="history-div">
                  <div className="date">2017.12</div>
                  <div className="circle" />
                  <div className="list">
                    D-Lab party'슈퍼그레잇상' 수상
                    <br />
                    '주식회사 잇마플' 설립
                  </div>
                </div>
                <div className="history-div">
                  <div className="date">2018.04</div>
                  <div className="circle" />
                  <div className="list">'sopoong','primer'투자업체 선정</div>
                </div>
                <div className="history-div">
                  <div className="date">2018.05</div>
                  <div className="circle" />
                  <div className="list">AIA오픈이노베이션랩 기업선정</div>
                </div>
                <div className="history-div">
                  <div className="date">2018.12</div>
                  <div className="circle" />
                  <div className="list">농식품창업콘테스트 '국무총리상'수상</div>
                </div>
              </div>
            </Col>
          </Row>
        </MicrosaltsHistoryContainer>
      </MicrosaltsHistorySection>

      <MicrosaltsMenuDevelopmentSection>
        <MicrosaltsMenuDevelopmentContainer>
          <Row>
            <Col span={24} md={24}>
              <Title>
                <strong>전문성</strong> 있는 식단개발
              </Title>
              <Description>
                임상영양사와 특급호텔 출신 요리사가 만나
                <br />
                환자들의 안전하고 맛있는 한 끼를 연구합니다.
              </Description>
              <div className="box-container">
                <div className="flex-column-div">
                  <div className="flex-column">
                    <ConsultantIcon />
                  </div>
                  의학/영양자문위원
                </div>
                <div className="plus-icon">
                  <Plus />
                </div>
                <div className="flex-column-div">
                  <div className="flex-column">
                    <ClinicaldietitianIcon />
                  </div>
                  임상영양사
                </div>
                <div className="plus-icon">
                  <Plus />
                </div>
                <div className="flex-column-div">
                  <div className="flex-column">
                    <DietitianIcon />
                  </div>
                  영양사
                </div>
                <div className="plus-icon">
                  <Plus />
                </div>
                <div className="flex-column-div">
                  <div className="flex-column text-indent">
                    <CookIcon />
                  </div>
                  조리장
                </div>
                <div className="dev-cook-teams">
                  <div>
                    <div className="cook-team-image">
                      <img src={CookTeam01} alt="쉐라톤 워커힐" className="sheraton" />
                    </div>
                    <div>쉐라톤 워커힐</div>
                  </div>
                  <div>
                    <div className="cook-team-image">
                      <img src={CookTeam02} alt="하얏트" className="hyatt" />
                    </div>
                    <div>하얏트</div>
                  </div>
                  <div>
                    <div className="cook-team-image">
                      <img src={CookTeam03} alt="르 꼬르동 블루" className="blue" />
                    </div>
                    <div>르 꼬르동 블루</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </MicrosaltsMenuDevelopmentContainer>
      </MicrosaltsMenuDevelopmentSection>

      <MicrosaltsPartnerSection>
        <MicrosaltsPartnerContainer>
          <Row>
            <Col span={24} md={24}>
              <Title>
                맛있저염의 <strong>협력 파트너</strong>
              </Title>
            </Col>
            <Col span={24} md={24}>
              <div className="partner-lists-div">
                <div className="partner-list">
                  <img src={Sopoong} alt="sopoong" />
                </div>
                <div className="partner-list">
                  <img src={Primer} alt="primer" />
                </div>
                <div className="partner-list">
                  <img src={Sk} alt="sk사회적기업가센터" />
                </div>
                <div className="partner-list">
                  <img src={Fact} alt="FACT 농업기술실용화재단" />
                </div>
                <div className="partner-list">
                  <img src={NPOIT} alt="비영리IT지원센터" />
                </div>
                <div className="partner-list">
                  <img src={SeoulCenter} alt="서울먹거리창업센터" />
                </div>
                <div className="partner-list">
                  <img src={SuwonWomen} alt="수원여자대학교" />
                </div>
                <div className="partner-list">
                  <img src={LH} alt="LH 소셜벤처" />
                </div>
                <div className="partner-list">
                  <img src={KAIST} alt="KAIST 경영대학" />
                </div>
                <div className="partner-list">
                  <img src={KDB} alt="KDB 산업은행" />
                </div>
                <div className="partner-list">
                  <img src={AIA} alt="AIA Healthier Longer Better Lives" />
                </div>
                <div className="partner-list">
                  <img src={SeoulHub} alt="Seoul StartUp HUB" />
                </div>
              </div>
            </Col>
          </Row>
        </MicrosaltsPartnerContainer>
      </MicrosaltsPartnerSection>

      <FooterBannerSection>
        <FooterBannerContainer>
          <Row>
            <Col span={24} md={24}>
              <Title>
                맛있저염과 함께
                <br />
                안심되고 즐거운 식사하세요
              </Title>
              <Link href={allRecordResultExist ? '/diagnosis-report' : '/diagnosis'}>
                <a>
                  <Button style={{ textAlign: 'center' }}>
                    맞춤식단 주문하기
                  </Button>
                </a>
              </Link>
            </Col>
          </Row>
        </FooterBannerContainer>
      </FooterBannerSection>
    </Layout>
  );
};

const Wrapper = styled.div``;
const Content = styled.div`
  text-align: center;
  * {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  h2 {
    font-size: ${props => props.theme.fontSize.mobile.headlineOne};
    margin-bottom: 4rem;
  }
`;

const Button = styled.button`
  display: block;
  width: 100%;
  height: 4.8rem;
  font-size: ${props => props.theme.fontSize.mobile.button};
  background-color: #ff9d46;
  color: #fff;
  font-weight: 700;
  ${props => props.theme.device.md} {
    width: 40%;
    margin: 0 auto;
  }
`;

const Description = styled.div`
  width: 100%;
  text-align: center;
  font-size: ${props => props.theme.fontSize.mobile.button};
  font-size: 1.7rem;
`;

const Underline = styled.div`
  width: 10.9rem;
  margin: 1.5rem 0 4rem 0;
  border-bottom: 1px solid #ff9d46;
`;

const MicrosaltsIntroductionSection = styled.div`
  height: 64.8rem;
  background-image: url(${MicrosaltsBanner});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  .microsalts-introduction-div {
    margin-top: 20rem;
    display: flex;
    flex-direction: Column;
    justify-content: center;
    align-items: center;
    span {
      font-family: 'Mr Dafoe', cursive;
      font-size: 3rem;
      color: #ff9d46;
      margin-bottom: 1.2rem;
      margin-top: 5rem;
    }
    h1 {
      margin-bottom: 0;
    }
  }
  ${props => props.theme.device.md} {
    height: 63rem;
    background-image: url(${DesktopMicrosaltsBanner});
    background-position: center;
    background-size: cover;
    .microsalts-introduction-div {
      padding-top: 1rem;
      h1 {
        font-size: 4.2rem;
      }
      span {
        font-size: 4.2rem;
      }
    }
  }
`;
const MicrosaltsIntroductionContainer = styled(Container)``;

const MicrosaltsHistorySection = styled.div`
  padding: 7.2rem 0 7.2rem;
`;
const MicrosaltsHistoryContainer = styled(Container)`
  display: flex;
  justify-content: center;
  .history-list-div {
    display: flex;
    flex-direction: column;
    .history-div {
      width: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-align: left;
      font-size: ${props => props.theme.fontSize.mobile.bodyThree};

      .circle {
        position: relative;
        left: 0.7rem;
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 50%;
        background-color: #2f6ecd;
      }
      .list {
        padding: 0 0 3rem 2.4rem;
        flex-basis: 80%;
        height: auto;
        border-left: 1px solid #2f6ecd;
      }
    }
  }
`;

const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 4rem;
  text-align: center;

  ${props => props.theme.device.md} {
    font-size: 3.6rem;
    margin-bottom: 4.6rem;
  }
`;

const MicrosaltsMenuDevelopmentSection = styled.div`
  height: 93.6rem;
  background-image: url(${MenuDevelopmentBackground});
  background-position: center;
  background-size: cover;
  ${props => props.theme.device.md} {
    background-image: url(${DesktopMenuDevelopmentBackground});
    height: 70rem;
  }
`;
const MicrosaltsMenuDevelopmentContainer = styled(Container)`
  max-width: 96.2rem;
  .box-container {
    margin-top: 5rem;
    padding: 0 3rem 5rem 3rem;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    .dev-cook-teams {
      margin-top: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;
      font-size: 1.2rem;
      color: #808080;
      font-weight: bold;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        .cook-team-image {
          width: 7.7rem;
          padding-bottom: 1rem;
        }
        img.sheraton {
          width: 5.2rem;
          height: 5.4rem;
        }
        img.hyatt {
          width: 9.2rem;
          height: 3.2rem;
          margin-bottom: 1rem;
        }
        img.blue {
          width: 5.5rem;
          height: 5.6rem;
        }
      }
    }
    .plus-icon {
      display: none;
    }
  }
  .flex-column-div {
    font-weight: 700;
    text-align: center;
    font-size: ${props => props.theme.fontSize.mobile.bodyTwo};
    .text-indent {
      margin-bottom: 2.3rem;
    }
  }
  .flex-column {
    margin: 4rem 0 0;
    display: flex;
    width: auto;
    height: 11.3rem;
  }
  ${props => props.theme.device.md} {
    .box-container {
      padding: 0 13.5rem 4rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .plus-icon {
        height: 11.3rem;
        display: block;
        padding-top: 5rem;
        margin: 0 5rem;
      }
      .dev-cook-teams {
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        margin: 2rem 3.6rem 0;
        width: 52%;
        background-color: #f8f8f8;
        border-radius: 65px;
        padding: 2rem;
      }
    }
  }
`;

const MicrosaltsPartnerSection = styled.div`
  padding: 6rem 0;
`;
const MicrosaltsPartnerContainer = styled(Container)`
  margin: 0 3.9rem;
  .partner-lists-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    .partner-list {
      width: 12.8rem;
      height: 10rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: auto;
        height: auto;
      }
    }
  }
  ${props => props.theme.device.md} {
    margin: 0 auto;
    .partner-lists-div {
      .partner-list {
        width: 24.8rem;
        height: 10rem;
        img {
          width: auto;
        }
      }
    }
  }
`;

const FooterBannerSection = styled.div`
  height: 30rem;
  background-image: url(${FooterBanner});
  background-position: center;
  background-size: cover;
  ${props => props.theme.device.md} {
    height: 36rem;
    background-image: url(${DesktopFooterBanner});
  }
`;
const FooterBannerContainer = styled(Container)`
  padding: 9rem 0 0 0;
  h2 {
    color: #fff;
    font-weight: 700;
  }
`;

export default MicrosaltsIntroduction;
